const messages = {
  title: "Vedligeholdelse!",
  description:
    'Der udføres i øjeblikket nødvendigt vedligeholdelsesarbejde på serverne.<br/><br/>Derfor har du i øjeblikket ikke adgang til <b>BRIDGESTONE <span class="text-danger">PLUS</span></b>.<br/><br/>Vi beder om din tålmodighed og takker dig for din forståelse.<br/><br/> Dit Bridgestone-team',
}
export default {
  messages
}
